// extracted by mini-css-extract-plugin
module.exports = {"title":"LanguagesListModal_title_38hLy","panel":"LanguagesListModal_panel_1R2cf"};